import React, { ReactNode } from 'react'
import { WebsitePageBodyContainer } from './ui/website-page-body-container'

export interface CommonWebsitePageBodyNewProps {
  htmlAttrId: string
  children: ReactNode
}

export const CommonWebsitePageBodyNew = ({
  htmlAttrId,
  children,
}: CommonWebsitePageBodyNewProps) => {
  return (
    <WebsitePageBodyContainer id={htmlAttrId}>
      {children}
    </WebsitePageBodyContainer>
  )
}
